import React from 'react';
import { Platform, Pressable, View } from 'react-native';
import Text from '@/components/Typography/Text';

export function composerModePillMetrics(compact, placement) {
  if (placement === 'header') return { minWidth: 118, padH: 28, padV: 8, fontSize: 17, trackPad: 4 };
  if (compact) return { minWidth: 118, padH: 28, padV: 12, fontSize: 17, trackPad: 5 };
  return { minWidth: 112, padH: 26, padV: 7, fontSize: 16, trackPad: 4 };
}

// Presentation shared by web, Mac and Windows; the host owns mode admission.
export default function ComposerModePills({ value, onChange, colors, compact = false, placement, disabled = false,
  label, modes = [{ id: 'chat', label: 'Chat' }, { id: 'work', label: 'Work' }] }) {
  const metrics = composerModePillMetrics(compact, placement);
  return <View accessibilityLabel={label} style={{ flexDirection: 'row', alignItems: 'center', padding: metrics.trackPad,
    borderRadius: 999, backgroundColor: colors.solid_color_tertiary, flexShrink: 0, alignSelf: 'center' }}>
    {modes.map(item => {
      const selected = value === item.id;
      return <Pressable key={item.id} accessibilityRole="button" accessibilityLabel={item.label} accessibilityHint={item.hint}
        accessibilityState={{ selected, disabled }} disabled={disabled}
        {...(Platform.OS === 'web' ? { 'aria-pressed': selected } : {})}
        onPress={() => { if (!disabled && !selected) onChange?.(item.id); }}
        style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', minWidth: metrics.minWidth,
          paddingHorizontal: metrics.padH, paddingVertical: metrics.padV, borderRadius: 999,
          backgroundColor: selected ? colors.solid_color_primary : 'transparent', ...(Platform.OS === 'web' ? { cursor: 'pointer' } : {}) }}>
        <Text weight="semibold" style={{ color: selected ? colors.text_color_primary : colors.text_color_secondary, fontSize: metrics.fontSize }}>{item.label}</Text>
      </Pressable>;
    })}
  </View>;
}
